// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageTapBar_container_2pu_p","flag":"LanguageTapBar_flag_1RuGl","arrow":"LanguageTapBar_arrow_29XFR","invertedColor":"LanguageTapBar_invertedColor_3ktX0"};